import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import NatalWheel from '../NatalWheel';

import AccordionSection from './AccordionSection';

export default function NatalChartResult({

  chart,

  summary,

  interpretations,

  openAcc,

  toggleAcc,

  helpers,

}) {
  const { t } = useTranslation('natal');

  const [activeTab, setActiveTab] = useState('planets');
  const [expandedAspectDetails, setExpandedAspectDetails] = useState({});
  const [showAllAspects, setShowAllAspects] = useState(false);
  const [expandedPlanetDetails, setExpandedPlanetDetails] = useState({});

  if (!chart) return null;

  const {

    tSign,
    tPlanet,
    formatDegree,
    getDisplayDegree,
    formatRetro,
    ensureArray,
    renderBulletChipText,
    stripMd,
    buildPatternRowsFromBullets,
    aspectTitleFromItem,
    aspectTextFromItem,
    aspectMetaParts,
    aspectTypeFromItem,
    aspectToneMeta,
    buildEditorialAspectSections,
    aspectIntensityTier,
    prioritizeAspects,
    aspectBadgeStyle,
    aspectSymbol,
    tAspect,
    safeIntegratedTitle,
    safeIntegratedSubtitle,
    decoratePlanetCardTitle,
    splitLines,
    isStructuredInterpretationLine,
    stripPrefix,
    lineKind,
    normalizePlanetHeaderLine,
    isDecorativeOnlyLine,
    buildCompactPlanetEditorial,
    compactPlacementDegree,
    buildExpandedPlanetEditorial,

  } = helpers;

  const orderedAspects = prioritizeAspects(ensureArray(interpretations?.aspects));

  return (

    <div
      className="natal-scroll-surface natal-result-shell"
      style={{
        marginTop: 18,
        padding: '12px 12px 14px',
        border: '1px solid rgba(247,210,106,0.38)',
        boxShadow: '0 0 18px rgba(0,0,0,0.7)',
        display: 'flex',
        flexDirection: 'column',
        gap: 14,
      }}
    >
                {/* Encabezado del bloque de resultados */}
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-end',
                    gap: 8,
                  }}
                >
                  <div
                    style={{
                      fontSize: 13,
                      textTransform: 'uppercase',
                      letterSpacing: 1,
                      color: '#F7D26A',
                      fontWeight: 800,
                    }}
                  >
                    ✨ {t('summary')}
                  </div>
                  <div
                    style={{
                      fontSize: 11,
                      opacity: 0.7,
                    }}
                  >
                    {t('basedOnBirthData')}
                  </div>
                </div>

                {/* Resumen principal */}
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr',
                    gap: 6,
                    fontSize: 13,
                    background: 'rgba(0,0,0,0.25)',
                    borderRadius: 10,
                    padding: '8px 10px',
                    border: '1px solid rgba(255,255,255,0.14)',
                  }}
                  className="natal-section-surface natal-summary-card"
                >
                  <div>
                    <span style={{ fontWeight: 700 }}>☀ {t('sun')}:</span>{' '}
                    <span>
                      {tSign(chart.sun?.sign)}{' '}
                      {getDisplayDegree(chart.sun) != null && `(${formatDegree(getDisplayDegree(chart.sun))})`}
                      {' — '}
                      <span style={{ opacity: 0.85 }}>
                        {t('house')} {chart.sun?.house || '—'}
                      </span>
                    </span>
                  </div>
                  <div>
                    <span style={{ fontWeight: 700 }}>🌙 {t('moon')}:</span>{' '}
                    <span>
                      {tSign(chart.moon?.sign)}{' '}
                      {getDisplayDegree(chart.moon) != null && `(${formatDegree(getDisplayDegree(chart.moon))})`}
                      {' — '}
                      <span style={{ opacity: 0.85 }}>
                        {t('house')} {chart.moon?.house || '—'}
                      </span>
                    </span>
                  </div>
                  <div>
                    <span style={{ fontWeight: 700 }}>↗ {t('ascendant')}:</span>{' '}
                    <span>
                      {tSign(chart.ascendant?.sign)}{' '}
                      {getDisplayDegree(chart.ascendant) != null &&
                        `(${formatDegree(getDisplayDegree(chart.ascendant))})`}
                    </span>
                  </div>
                </div>

                {/* Rueda astrológica */}
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginTop: 8,
                    marginBottom: 6,
                  }}
                >
                  <div
                    className="natal-wheel-card"
                    style={{
                      width: 'min(260px, 72vw)',
                      height: 'min(260px, 72vw)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <NatalWheel planets={chart.planets} houses={chart.houses} />
                  </div>
                </div>

                {/* Planetas detallados */}
                <div className="natal-chart-tabs">
        <button
          type="button"
          className={`natal-chart-tab${
            activeTab === 'planets'
              ? ' is-active'
              : ''
          }`}
          onClick={() => setActiveTab('planets')}
        >
          🪐 {t('planetByPlanet')}
        </button>

        <button
          type="button"
          className={`natal-chart-tab${
            activeTab === 'houses'
              ? ' is-active'
              : ''
          }`}
          onClick={() => setActiveTab('houses')}
        >
          🏛 {t('houses')}
        </button>
      </div>

      {activeTab === 'planets' && Array.isArray(chart.planets) && chart.planets.length > 0 && (
                  <div
                    style={{
                      borderTop: '1px solid rgba(255,255,255,0.16)',
                      paddingTop: 10,
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: 4,
                      }}
                    >
                      <div
                        style={{
                          fontSize: 13,
                          textTransform: 'uppercase',
                          letterSpacing: 1,
                          color: '#F7D26A',
                          fontWeight: 700,
                        }}
                      >
                        🌌 {t('planetByPlanet')}
                      </div>
                      <div
                        style={{
                          fontSize: 11,
                          opacity: 0.7,
                        }}
                      >
                        {t('planetTableSubtitle')}
                      </div>
                    </div>

                    <div
                      style={{
                        fontSize: 12,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2
                      }}
                    >
                      {/* Encabezado de columnas */}
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          gap: 8,
                          padding: '2px 0 4px',
                          borderBottom: '1px solid rgba(255,255,255,0.18)',
                          fontSize: 11,
                          opacity: 0.8,
                        }}
                      >
                        <div style={{ flex: 1 }}>{t('planet')}</div>
                        <div style={{ flex: 1, textAlign: 'right' }}>{t('signAndDegree')}</div>
                        <div style={{ width: 70, textAlign: 'right' }}>{t('house')}</div>
                        <div style={{ width: 80, textAlign: 'right' }}>{t('motion')}</div>
                      </div>

                      {chart.planets.map((p, idx) => (
                        <div
                          key={p.name || p.planet || idx}
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            gap: 8,
                            padding: '4px 0',
                            borderBottom:
                              idx === chart.planets.length - 1
                                ? 'none'
                                : '1px dotted rgba(255,255,255,0.08)',
                          }}
                        >
                          <div style={{ flex: 1, fontWeight: 600 }}>
                            {p.symbol || ''}{' '}
                            {tPlanet(p.name || p.planet)}
                          </div>
                          <div style={{ flex: 1, textAlign: 'right' }}>
                            {tSign(p.sign)}{' '}
                            {getDisplayDegree(p) != null && `(${formatDegree(getDisplayDegree(p))})`}
                          </div>
                          <div style={{ width: 70, textAlign: 'right', opacity: 0.85 }}>
                            {t('house')} {p.house || '—'}
                          </div>
                          <div style={{ width: 80, textAlign: 'right', opacity: 0.7 }}>
                            {formatRetro(p.isRetro)}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Casas */}
                {activeTab === 'houses' && Array.isArray(chart.houses) && chart.houses.length > 0 && (
                  <div
                    style={{
                      borderTop: '1px solid rgba(255,255,255,0.16)',
                      paddingTop: 10,
                      marginTop: 6,
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: 4,
                      }}
                    >
                      <div
                        style={{
                          fontSize: 13,
                          textTransform: 'uppercase',
                          letterSpacing: 1,
                          color: '#F7D26A',
                          fontWeight: 700,
                        }}
                      >
                        🏛️ {t('houses')}
                      </div>
                      <div
                        style={{
                          fontSize: 11,
                          opacity: 0.7,
                        }}
                      >
                        {t('signAndDegree')}
                      </div>
                    </div>

                    <div
                      style={{
                        fontSize: 12,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2
                      }}
                    >
                      {/* Encabezado de columnas */}
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          gap: 8,
                          padding: '2px 0 4px',
                          borderBottom: '1px solid rgba(255,255,255,0.18)',
                          fontSize: 11,
                          opacity: 0.8,
                        }}
                      >
                        <div style={{ flex: 1 }}>{t('house')}</div>
                        <div style={{ flex: 1, textAlign: 'right' }}>{t('sign')}</div>
                        <div style={{ width: 80, textAlign: 'right' }}>{t('degree')}</div>
                      </div>

                      {chart.houses.map((h, idx) => (
                        <div
                          key={h.house || idx}
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            gap: 8,
                            padding: '4px 0',
                            borderBottom:
                              idx === chart.houses.length - 1
                                ? 'none'
                                : '1px dotted rgba(255,255,255,0.08)',
                          }}
                        >
                          <div style={{ flex: 1, fontWeight: 600 }}>{t('house')} {h.house}</div>
                          <div style={{ flex: 1, textAlign: 'right' }}>
                            {tSign(h.sign || h.zodiacSign)}
                          </div>
                          <div style={{ width: 80, textAlign: 'right', opacity: 0.8 }}>
                            {formatDegree(getDisplayDegree(h))}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Interpretación (si viene del backend) */}
    {(summary || interpretations) ? (
      <div
        className="natal-stable-block"
        style={{
      borderTop: '1px solid rgba(255,255,255,0.16)',
      paddingTop: 10,
      marginTop: 6,
      background: 'rgba(25, 6, 48, 0.98)',
      borderRadius: 12,
      paddingLeft: 2,
      paddingRight: 2,
      overflow: 'visible',
    }}
      >
        <div
          style={{
            fontSize: 13,
            textTransform: 'uppercase',
            letterSpacing: 1,
            color: '#F7D26A',
            fontWeight: 700,
            marginBottom: 6,
          }}
        >
          🔮 {t('interpretation')}
        </div>

        {summary?.text ? (
          <div
            style={{
              fontSize: 12,
              lineHeight: 1.35,
              opacity: 0.92,
              background: 'rgba(0,0,0,0.22)',
              border: '1px solid rgba(255,255,255,0.12)',
              borderRadius: 10,
              padding: '10px 12px',
              marginBottom: 10,
              whiteSpace: 'pre-line',
            }}
          >
            {summary.text}
          </div>
                    ) : null}
                    {interpretations?.interpretationVersion ? (
      <details className="natal-technical-details">
        <summary>{t('technicalInformation')}</summary>
        <span>{t('interpretationEngine', { version: interpretations.interpretationVersion })}</span>
      </details>
    ) : null}

      <div
      className="natal-stable-block"
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 18,
        marginTop: 4,
        background: 'rgba(25, 6, 48, 0.98)',
        borderRadius: 12,
        overflow: 'visible',
      }}
    >
          {/* ✦ Energía dominante */}
          {interpretations?.dominantEnergy ? (
            <AccordionSection
              id="dominant"
              title={`✦ ${t('dominantEnergy')}`}
              subtitle={t('dominantEnergySubtitle')}
              isOpen={openAcc === 'dominant'}
              onToggle={() => toggleAcc('dominant')}
            >
              <div className="dominant-card">
                <div className="dominant-kicker">{t('chartDominant')}</div>



                {ensureArray(interpretations.dominantEnergy.paragraphs).map((p, i) => (
                  <div key={`dom-p-${i}`} className="dominant-paragraph">
                    {p}
                  </div>
                ))}

                {ensureArray(interpretations.dominantEnergy.bullets)
                  .filter(Boolean).length > 0 ? (
                  <div className="dominant-metrics-grid">
                    {ensureArray(interpretations.dominantEnergy.bullets)
                      .filter(Boolean)
                      .map((bullet, index) => {
                        const cleanText = renderBulletChipText(bullet)
                          .replace(
                            /\s*\([^)]*pts? ponderados?\)\s*/gi,
                            ''
                          )
                          .trim();

                        const [
                          rawLabel,
                          ...rawValueParts
                        ] = cleanText.split(':');

                        const label = String(
                          rawLabel || ''
                        ).trim();

                        const value = rawValueParts
                          .join(':')
                          .trim();

                        return (
                          <div
                            key={`dom-b-${index}`}
                            className="dominant-metric-card"
                          >
                            <span className="dominant-metric-label">
                              {label || 'Dominante'}
                            </span>

                            <strong className="dominant-metric-value">
                              {(() => {
                                const normalizedLabel = label.toLowerCase();

                                const elementIcons = {
                                  tierra: '⛰️',
                                  agua: '💧',
                                  fuego: '🔥',
                                  aire: '🌬️',
                                };

                                const modalityIcons = {
                                  cardinal: '⚡',
                                  fija: '◆',
                                  fijo: '◆',
                                  mutable: '〰️',
                                };

                                const normalizedValue = String(
                                  value || cleanText || ''
                                )
                                  .trim()
                                  .toLowerCase();

                                const icon = normalizedLabel.includes('elemento')
                                  ? elementIcons[normalizedValue] || '✦'
                                  : normalizedLabel.includes('modalidad')
                                    ? modalityIcons[normalizedValue] || '✦'
                                    : '✦';

                                return `${icon} ${value || cleanText}`;
                              })()}
                            </strong>
                          </div>
                        );
                      })}
                  </div>
                ) : null}

                <div className="section-gap-fix" />
              </div>
            </AccordionSection>
          ) : null}

          {/* ✦ Patrones principales */}
          {interpretations?.patternSummary ? (
            <AccordionSection
              id="patterns"
              title={`✦ ${t('mainPatterns')}`}
              subtitle={t('visibleFocuses')}
              isOpen={openAcc === 'patterns'}
              onToggle={() => toggleAcc('patterns')}
            >
              <div className="pattern-card">
                <div className="pattern-kicker">{t('structuralReading')}</div>


                {ensureArray(interpretations.patternSummary.paragraphs).filter(Boolean).length > 0 ? (
                  <div className="integrated-copy">
                    {interpretations.patternSummary.paragraphs.filter(Boolean).map((p, i) => (
                      <div key={`pat-p-${i}`} className="integrated-paragraph">
                        {stripMd(p)}
                      </div>
                    ))}
                  </div>
                ) : null}

                {/* Structured label */}
    {(() => {
      const patternRows = buildPatternRowsFromBullets(interpretations.patternSummary.bullets);

      return patternRows.length > 0 ? (
        <>
          <div
            style={{
              marginTop: 10,
              fontSize: 11,
              textTransform: 'uppercase',
              letterSpacing: 0.6,
              color: '#F7D26A',
              opacity: 0.9,
              fontWeight: 900
            }}
          >
            Mapa estructural
          </div>

          <div
            style={{
              marginTop: 10,
              display: 'flex',
              flexDirection: 'column',
              gap: 8,
              fontSize: 12,
              lineHeight: 1.45,
              color: 'rgba(255,255,255,0.92)'
            }}
          >
            {patternRows.map((row, i) => (
              <div
                key={`pat-row-${i}`}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 2
                }}
              >
                {row.label ? (
                  <div style={{ color: '#F7D26A', fontWeight: 900 }}>
                    {row.label}
                  </div>
                ) : null}

                <div style={{ fontWeight: 700 }}>
                  {row.value}
                </div>
              </div>
            ))}
          </div>
        </>
      ) : null;
    })()}
              </div>
            </AccordionSection>
          ) : null}
          {/* ✨ Aspectos */}
          {ensureArray(interpretations?.aspects).length > 0 ? (
            <AccordionSection
              id="aspects"
              title={`✨ ${t('aspect')}`}
              subtitle={t('keyConnections')}
              isOpen={openAcc === 'aspects'}
              onToggle={() => toggleAcc('aspects')}
            >
              <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
                {orderedAspects.slice(0, showAllAspects ? orderedAspects.length : 5).map((a, idx) => {
                  const title = aspectTitleFromItem(a);
                  const text = aspectTextFromItem(a);
                  const meta = aspectMetaParts(a);
                  const type = aspectTypeFromItem(a);
                  const toneMeta = aspectToneMeta(a);
                  const editorial = buildEditorialAspectSections(text);
                  const aspectId = a.key || `${title}-${idx}`;
                  const isExpanded = Boolean(expandedAspectDetails[aspectId]);
                  const intensityTier = aspectIntensityTier(a.score);
                  const toneStyle = aspectBadgeStyle(toneMeta.kind);

                  return (
                    <div key={aspectId} className={`aspect-card aspect-tier-${intensityTier}`}>
                      <div className="aspect-top">
                        <div className="aspect-titleWrap">
                          <div className="aspect-kicker">{t('keyIdea', { defaultValue: 'Idea clave' })}</div>
                          <div className="aspect-title">{title}</div>
                        </div>

                        <div className="aspect-glyph" aria-hidden="true">
                          {aspectSymbol(type)}
                        </div>
                      </div>

                      
                      <div className="aspect-chiprow">
                        <span className="aspect-chip" style={toneStyle}>
                          {toneMeta.label}
                        </span>

                        {meta
                          .filter((m) => m !== toneMeta.label)
                          .map((m, i) => (
                            <span
                              key={`${m}-${i}`}
                              className="aspect-chip aspect-chip-secondary"
                            >
                              {m}
                            </span>
                          ))}
                        {typeof a.score === 'number' && Number.isFinite(a.score) ? (
                          <span className="aspect-intensity-inline" title={`${Math.round(a.score)}/100`}>
                            <span>{Math.round(a.score)}</span>
                            <span className="aspect-intensity-track" aria-hidden="true"><span style={{ width: `${Math.max(0, Math.min(100, a.score))}%` }} /></span>
                          </span>
                        ) : null}
                      </div>

                      {text ? (
                        <div className="aspect-content">
                          {editorial.lead.length ? (
                            <div className="aspect-editorial-block aspect-key-idea">
                              <div className="aspect-section-label">{t('keyIdea', { defaultValue: 'Idea clave' })}</div>
                              <div className="aspect-intro">{editorial.lead.join(' ')}</div>
                            </div>
                          ) : null}
                          {editorial.strengths.length ? (
                            <div className="aspect-editorial-block">
                              <div className="aspect-section-label">{t('strengths', { defaultValue: 'Fortalezas' })}</div>
                              <ul className="aspect-bullet-list">{editorial.strengths.slice(0, 4).map((item, i) => <li key={`strength-${i}`}>{item}</li>)}</ul>
                            </div>
                          ) : null}
                          {editorial.challenges.length ? (
                            <div className="aspect-editorial-block">
                              <div className="aspect-section-label">{t('challenges', { defaultValue: 'Desafíos' })}</div>
                              <ul className="aspect-bullet-list">{editorial.challenges.slice(0, 3).map((item, i) => <li key={`challenge-${i}`}>{item}</li>)}</ul>
                            </div>
                          ) : null}
                          {editorial.advice.length ? (
                            <div className="aspect-editorial-block aspect-advice">
                              <div className="aspect-section-label">{t('key', { defaultValue: 'Clave' })}</div>
                              <div className="aspect-body">{editorial.advice.join(' ')}</div>
                            </div>
                          ) : null}
                          {editorial.detail.length && isExpanded ? (
                            <div className="aspect-editorial-detail">{editorial.detail.join(' ')}</div>
                          ) : null}
                          {editorial.detail.length ? (
                            <button
                              type="button"
                              className="aspect-detail-toggle"
                              aria-expanded={isExpanded}
                              onClick={() => setExpandedAspectDetails((previous) => ({ ...previous, [aspectId]: !isExpanded }))}
                            >
                              {isExpanded ? t('hideDetails', { defaultValue: 'Ocultar detalle' }) : t('readMore', { defaultValue: 'Ver lectura completa' })}
                            </button>
                          ) : null}
                        </div>
                      ) : null}
    {text && <div style={{ height: 2 }} />}
                      {!text && type ? (
                        <div className="aspect-fallback">
                          {t('aspectExplanation', { aspect: tAspect(type).toLowerCase() })}
                        </div>
                      ) : null}
                    </div>
                  );
                })}
                {orderedAspects.length > 5 ? (
                  <button type="button" className="aspect-list-toggle" onClick={() => setShowAllAspects((previous) => !previous)}>
                    {showAllAspects ? t('showLess', { defaultValue: 'Ocultar aspectos secundarios' }) : `${t('showMoreAspects', { defaultValue: 'Ver más aspectos' })} (${orderedAspects.length - 5})`}
                  </button>
                ) : null}
              </div>
            </AccordionSection>
          ) : null}

          {/* 2️⃣ Integrada */}
          {interpretations?.integrated ? (
            <AccordionSection
              id="integrated"
              title={`🪐 ${t('integratedReading')}`}
              subtitle={t('unifiedSynthesis')}
              isOpen={openAcc === 'integrated'}
              onToggle={() => toggleAcc('integrated')}
            >
              <div className="integrated-card">
                <div className="integrated-kicker">{t('premiumSynthesis')}</div>

                {(() => {
                  const integratedTitle = safeIntegratedTitle(
                    interpretations.integrated.title,
                    '🪐 Lectura integrada'
                  );
                  return integratedTitle ? (
                    <div className="integrated-title">{integratedTitle}</div>
                  ) : null;
                })()}

                {(() => {
                  const integratedSubtitle = safeIntegratedSubtitle(
                    interpretations.integrated.subtitle,
                    t('unifiedSynthesis')
                  );
                  return integratedSubtitle ? (
                    <div className="integrated-subtitle">{integratedSubtitle}</div>
                  ) : null;
                })()}

                {ensureArray(interpretations.integrated.paragraphs).filter(Boolean).length > 0 ? (
                  <div className="integrated-copy">
                    {interpretations.integrated.paragraphs.filter(Boolean).map((p, i) => (
                      <div key={`int-p-${i}`} className="integrated-paragraph">
                        {stripMd(p)}
                      </div>
                    ))}
                  </div>
                ) : null}

                {ensureArray(interpretations.integrated.bullets)
                  .filter(Boolean).length > 0 ? (
                  <div className="integrated-metrics-grid">
                    {ensureArray(interpretations.integrated.bullets)
                      .filter(Boolean)
                      .map((bullet, index) => {
                        const cleanText = renderBulletChipText(bullet).trim();
                        const [rawLabel, ...rawValueParts] =
                          cleanText.split(':');

                        const label = String(
                          rawLabel || ''
                        ).trim();

                        const value = rawValueParts
                          .join(':')
                          .trim();

                        return (
                          <div
                            key={`int-b-${index}`}
                            className="integrated-metric-card"
                          >
                            <span className="integrated-metric-label">
                              {label || 'Clave'}
                            </span>

                            <strong className="integrated-metric-value">
                              {value || cleanText}
                            </strong>
                          </div>
                        );
                      })}
                  </div>
                ) : null}

    <div className="section-gap-fix" />
              </div>
            </AccordionSection>
          ) : null}

          {/* 🔮 Planeta por planeta */}
          <AccordionSection
            id="items"
            title={`🔮 ${t('planetByPlanet')}`}
            subtitle={t('planetByPlanetSubtitle')}
            isOpen={openAcc === 'items'}
            onToggle={() => toggleAcc('items')}
          >
            {ensureArray(interpretations?.items).length > 0 ? (
              <div className="natal-stable-block" style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
                {interpretations.items.map((it, idx) => {
                  const rawTitle = stripMd(it.title);
                  const subtitleParts = stripMd(it.subtitle)
                    .replace(
                      /\s*\.?\s*(?=Grado zodiacal\s*:)/gi,
                      '\n'
                    )
                    .split(/\n+/)
                    .map((part) => part.trim())
                    .filter(Boolean);

                  const subtitle = subtitleParts[0] || '';
                  const subtitleDegree = subtitleParts
                    .slice(1)
                    .join(' ')
                    .trim();
                  const placementDegree = compactPlacementDegree(subtitleDegree);
                  const houseRulerMatch = subtitle.match(/Regente(?: de la casa)?\s*:?\s*([^·]+)/i);
                  const compactHouseRuler = houseRulerMatch ? `Regente de la casa ${houseRulerMatch[1].trim()}` : '';
                  const cleanSubtitle = subtitle
                    .replace(/\s*[·|]\s*Regente(?: de la casa)?\s*:?\s*[^·|]+/i, '')
                    .replace(/^Casa\s*\d+\s*[·|]?\s*/i, '')
                    .trim();
                  const title = decoratePlanetCardTitle(rawTitle, subtitle);

                  // La primera paragraph suele traer varias líneas (energía / expresión / área / integración...)
                  const paragraphs = ensureArray(it.paragraphs);
                  const mainLines = paragraphs.length ? splitLines(paragraphs[0]) : [];
                  const extraParas = paragraphs
                    .slice(1)
                    .map((p) => stripMd(p))
                    .filter(Boolean)
                    .filter((p) => !isStructuredInterpretationLine(p));

                  // bullets (regente / grado / retro) como chips
                  const chips = ensureArray(it.bullets)
                    .flatMap((bullet) => {
                      const rawText = stripMd(bullet).trim();

                      const normalizedText = rawText.replace(
                        /Regente del signo\s*:\s*(.*?)\.?\s*Grado zodiacal\s*:\s*([0-9]+(?:[.,][0-9]+)?°)\.?/i,
                        'Regente del signo: $1\nGrado zodiacal: $2.'
                      );

                      return normalizedText
                        .split(/\n+/)
                        .map((part) => part.trim())
                        .filter(Boolean);
                    });

                  // si no vienen líneas ricas, partimos todo
                  const effectiveLines = (
                    mainLines.length
                      ? mainLines
                      : splitLines(paragraphs.join('\n'))
                  )
                    .flatMap((line) =>
                      stripMd(line)
                        .replace(
                          /(?<=Regente del signo:\s*[^.]+)\.(?=Grado zodiacal:)/gi,
                          '\n'
                        )
                        .replace(
                          /(?<=Grado zodiacal:\s*[^.°]+°)\.(?=Movimiento retrógrado:)/gi,
                          '\n'
                        )
                        .split(/\n+/)
                        .map((x) => x.trim())
                        .filter(Boolean)
                    );

                  const normalizedEffectiveSet = new Set(
                    effectiveLines
                      .map((line) => stripPrefix(stripMd(line)))
                      .map((line) => String(line || '').trim().toLowerCase())
                      .filter(Boolean)
                  );
                  const filteredExtraParas = extraParas.filter((p) => {
                    const normalized = stripPrefix(stripMd(p)).trim().toLowerCase();
                    return normalized && !normalizedEffectiveSet.has(normalized);
                  });

                  const rows = effectiveLines
                    .map((line) => {
                      const cleanedLine = stripMd(line).trim();
                      return {
                        line: cleanedLine,
                        kind: lineKind(cleanedLine),
                        normalized: normalizePlanetHeaderLine(cleanedLine).toLowerCase(),
                      };
                    })
                    .filter(({ line, normalized }) => {
                      if (isDecorativeOnlyLine(line)) return false;

                      if (
                        /^(Regente del signo|Grado zodiacal|Movimiento retrógrado):/i.test(
                          line
                        )
                      ) {
                        return false;
                      }

                      const normalizedRawTitle = normalizePlanetHeaderLine(rawTitle).toLowerCase();
                      const normalizedDecoratedTitle = normalizePlanetHeaderLine(title).toLowerCase();

                      if (!normalized) return false;
                      if (normalized === normalizedRawTitle) return false;
                      if (normalized === normalizedDecoratedTitle) return false;
                      if (normalized.startsWith(normalizedRawTitle)) return false;

                      return true;
                    });
                  const compact = buildCompactPlanetEditorial(rows);
                  const expanded = buildExpandedPlanetEditorial(rows, compact);
                  const planetId = it.key || `${title}-${idx}`;
                  const isPlanetExpanded = Boolean(expandedPlanetDetails[planetId]);
                  const visibleChips = chips.filter((chip) => {
                    const normalizedChip = chip.toLowerCase();
                    return !normalizedChip.startsWith('regente del signo:')
                      && !normalizedChip.startsWith('grado zodiacal:');
                  });
                  const rulerChip = chips.find((chip) => chip.toLowerCase().startsWith('regente del signo:'));
                  const compactRuler = rulerChip ? rulerChip.replace(/^Regente del signo:\s*/i, 'Regente ') : '';

                  return (
                    <div key={`${title}-${idx}`} className="it-card natal-section-surface">
                      <div className="it-head">
                        <div style={{ minWidth: 0 }}>
                          <div className="it-title">{title}</div>
                          {cleanSubtitle ? (
                            <div className="it-sub">
                              {cleanSubtitle}
                            </div>
                          ) : null}

                          {subtitleDegree && isPlanetExpanded ? (
                            <div className="it-sub it-sub-degree">
                              {subtitleDegree}
                            </div>
                          ) : null}
                        </div>
                      </div>

                      {visibleChips.length > 0 || placementDegree || compactRuler || compactHouseRuler ? (
  <div className="it-chiprow">
    {placementDegree ? <span className="it-chip it-chip-degree">{placementDegree}</span> : null}
    {compactHouseRuler ? <span className="it-chip it-chip-ruler">{compactHouseRuler}</span> : null}
    {compactRuler ? <span className="it-chip it-chip-ruler">{compactRuler}</span> : null}
    {visibleChips.map((chip, chipIndex) => {
        const normalizedChip = chip.toLowerCase();

        const isRuler = false;

                            const isDegree = normalizedChip.startsWith(
                              'grado zodiacal:'
                            );

                            return (
                              <div
                                key={`chip-${idx}-${chipIndex}`}
                                className={`it-chip${
                                  isDegree
                                    ? ' it-chip-degree'
                                    : isRuler
                                      ? ' it-chip-ruler'
                                      : ''
                                }`}
                              >
                                {chip}
                              </div>
                            );
                          })}
                        </div>
                      ) : null}

                      {!isPlanetExpanded ? (
                        <div className="it-compact-body">
                          {compact.primary ? <div className="it-primary-insight">{compact.primary}</div> : null}
                          {compact.strengthChips.length ? (
                            <div className="it-compact-row"><span className="it-compact-label">{t('strength')}</span><div className="it-compact-chips">{compact.strengthChips.map((chip) => <span className="it-compact-chip" key={chip}>{chip}</span>)}</div></div>
                          ) : null}
                          {compact.challenge ? <div className="it-compact-row"><span className="it-compact-label">{t('challenge')}</span><span className="it-compact-challenge">{compact.challenge}</span></div> : null}
                        </div>
                      ) : null}
                      {isPlanetExpanded ? (
                        <div className="it-expanded-body">
                          {[
                            [t('howItWorks'), expanded.howItWorks],
                            [t('whereItManifests'), expanded.whereItManifests],
                            [t('nuance'), expanded.nuance],
                            [t('growthKey'), expanded.evolution],
                          ].filter(([, value]) => value).map(([label, value]) => (
                            <div className="it-expanded-section" key={label}>
                              <div className="it-expanded-label">{label}</div>
                              <div className="it-expanded-text">{value}</div>
                            </div>
                          ))}
                          {filteredExtraParas.length > 0 ? (
                            <div className="it-expanded-section it-expanded-technical">
                              <div className="it-expanded-label">{t('notes')}</div>
                              <div className="it-expanded-text">{filteredExtraParas.join(' ')}</div>
                            </div>
                          ) : null}
                        </div>
                      ) : null}
                      <button
                        type="button"
                        className="it-detail-toggle"
                        aria-expanded={isPlanetExpanded}
                        onClick={() => setExpandedPlanetDetails((previous) => ({ ...previous, [planetId]: !isPlanetExpanded }))}
                      >
                        {isPlanetExpanded ? t('hideAnalysis') : t('readFullAnalysis')}
                      </button>
                    </div>
                  );
                })}
              </div>
            ) : Array.isArray(interpretations?.planets) ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {interpretations.planets.map((it, idx) => (
                  <div
                    key={it.key || idx}
                    style={{
                      background: 'rgba(0,0,0,0.18)',
                      border: '1px solid rgba(255,255,255,0.10)',
                      borderRadius: 12,
                      padding: '10px 12px',
                    }}
                  >
                    <div style={{ fontWeight: 900, color: '#F7D26A', fontSize: 12 }}>
                      {it.title}
                    </div>
                    <div
                      style={{
                        fontSize: 12,
                        lineHeight: 1.35,
                        opacity: 0.92,
                        marginTop: 4,
                        whiteSpace: 'pre-line',
                      }}
                    >
                      {it.text}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div style={{ fontSize: 12, opacity: 0.75 }}>
                {t('noInterpretation')}
              </div>
            )}
          </AccordionSection>
        </div>
      </div>
    ) : (
      <p style={{ marginTop: 6, fontSize: 11, opacity: 0.75 }}>
        {t('comingSoon')}
      </p>
    )}
            </div>

  );

}
